(() => {
  if (window.townlineSearchReady) return;
  window.townlineSearchReady = true;
  const normalize = (value) => {
    const match = value.trim().match(/^(HC|OC|AF|CSP)\s*-?\s*(\d+)$/i);
    return match ? `${match[1].toUpperCase()}-${match[2]}` : value;
  };
  document.addEventListener('input', (event) => {
    if (event.target instanceof HTMLInputElement && event.target.name === 'q') {
      const value = normalize(event.target.value);
      if (value !== event.target.value) event.target.value = value;
    }
  }, true);
  document.addEventListener('submit', (event) => {
    const input = event.target.querySelector('input[name="q"]');
    if (input) input.value = normalize(input.value).trim();
  }, true);
})();
